import { createContext } from '@wordpress/element';
export const Context = createContext(undefined);
Context.displayName = 'MenuContext';